module.exports = __webpack_public_path__ + "static/media/upload.f6428fd5.svg";